const bannerTypes = ["small", "large"];

export { bannerTypes };
